const checkTaskOverdue = (taskPeriod) => {
  const tasktime = new Date(taskPeriod).getTime();
  const nowTime = new Date().getTime();
  return nowTime > tasktime;
};

export default checkTaskOverdue;
